import Vue from 'vue'
import Router from 'vue-router'
import HelloWorld from '@/components/HelloWorld'
import ShoppingCart from '../view/shopping-cart.vue'
import OrderCart from '@/view/order-cart'
import CartOrderdetail from '@/view/cart-order-detail'
import OrderStatusCart from '@/view/order-status-cart'
import Index from '@/view/index/index'
import Preview from '@/view/index/Preview'
import NewcomersList from '@/view/newcomer/newcomersList'
import GoodsSearch from '@/view/goodsSearch/goodsSearch'
import Inform from '@/view/index/inform'
import GoodDetails from '@/view/goodDetails/goodDetails'
import MoreAddrOrder from '@/view/order/moreAddrOrder'
import GuessLike from '@/view/guessLike/guessLike'
import NewAddress from '@/view/address/newAddress'
// import NewAddress from '@/view/address/addressMap'
// import NewAddress from '@/view/address/newAddress1'
import AddressList from '@/view/address/addressList'
import BindMobileNumber from '@/view/bindMobileNumber/bindMobileNumber'
import CmsPage from '@/view/cmssys/cmsPage'
import Map from '@/components/Map'
import ShoppingGold from '@/view/shoppingGold/shoppingGold'
import ShoppingGoldList from '@/view/shoppingGold/shoppingGoldList'
import ShoppingGoldInfo from '@/view/shoppingGold/shoppingGoldInfo'
import GoodsRate from '@/view/goodsRate/goodsRate'
import SendGiftGoods from '@/view/bindMobileNumber/sendGiftGoods'
import BuyerShowList from '@/view/buyersShow/buyerShowList'
import BuyerShowPage from '@/view/buyersShow/buyerShowPage'
import Elizabeth from '@/view/elizabeth/index'

Vue.use(Router)

export default new Router({
mode:'history',
  routes: [
    {
      path: '/shoppingCart',
      name: 'ShoppingCart',
      component: ShoppingCart,
      meta:{
        title:"购物车",
      }
    },
    {
      path: '/OrderCart',
      name: 'OrderCart',
      component: OrderCart,
      meta:{
        title:"购物车",
      }
    },
    {
      path: '/CartOrderdetail',
      name: 'CartOrderdetail',
      component: CartOrderdetail,
      meta:{
        title:"购物车订单详情",
      }
    },
    {
      path: '/OrderStatusCart',
      name: 'OrderStatusCart',
      component: OrderStatusCart,
      meta:{
        title:"购物车订单列表",
      }
    },
    {
      path: '/',
      name: 'Index',
      component: Index,
      meta:{
        title:"首页",
      }
    },
    {
      path: '/preview',
      name: 'Preview',
      component: Preview,
      meta:{
        title:"预览首页",
      }
    },
    {
      path: '/newcomersList',
      name: 'newcomersList',
      component: NewcomersList,
      meta:{
        title:"新人专享",
      }
    },
    {
      path: '/goodsSearch',
      name: 'GoodsSearch',
      component: GoodsSearch,
      meta:{
        title:"商品搜索",
      }
    },
    {
      path: '/inform',
      name: 'Inform',
      component: Inform,
      meta:{
        title:"通知",
      }
    },
    {
      path: '/goodDetails',
      name: 'GoodDetails',
      component: GoodDetails,
      meta:{
        title:"商品详情",
      }
    },
    {
      path: '/moreAddrOrder',
      name: 'MoreAddrOrder',
      component: MoreAddrOrder,
      meta:{
        title: "结算"
      }
    },
    {
      path: '/guessLike',
      name: 'GuessLike',
      component: GuessLike,
      meta:{
        title: "猜你喜欢"
      }
    },
    {
      path: '/newAddress',
      name: 'NewAddress',
      component: NewAddress,
      meta:{
        title: "新增地址"
      }
    },
    {
      path: '/addressList',
      name: 'AddressList',
      component: AddressList,
      meta:{
        title: "地址列表"
      }
    },
    {
      path: '/mapLocation',
      name: 'mapLocation',
      component: Map,
      meta:{
        title: "选择地址"
      }
    },
    {
      path: '/bindMobileNumber',
      name: 'BindMobileNumber',
      component: BindMobileNumber,
      meta:{
        title: "绑定手机号"
      }
    },
    {
      path: '/sendGiftGoods',
      name: 'SendGiftGoods',
      component: SendGiftGoods,
      meta:{
        title: "入群绑赠"
      }
    },
    {
      path: '/cmsPage',
      name: 'CmsPage',
      component: CmsPage,
      meta:{
        title:"集合页",
      }
    },
    {
      path: '/shoppingGold',
      name: 'ShoppingGold',
      component: ShoppingGold,
      meta:{
        title:"购物金",
      }
    },
    {
      path: '/shoppingGoldList',
      name: 'ShoppingGoldList',
      component: ShoppingGoldList,
      meta:{
        title:"购物金记录",
      }
    },
    {
      path: '/shoppingGoldInfo',
      name: 'ShoppingGoldInfo',
      component: ShoppingGoldInfo,
      meta:{
        title:"购物金订单详情",
      }
    },
    {
      path: '/rateList',
      name: 'GoodsRate',
      component: GoodsRate,
      meta:{
        title:"商品评价列表",
      }
    },
    {
      path: '/buyerShowList',
      name: 'buyerShowList',
      component: BuyerShowList,
      meta:{
        title:"用户晒单",
      }
    },
    {
      path: '/buyerShowPage',
      name: 'buyerShowPage',
      component: BuyerShowPage,
      meta:{
        title:"用户晒单",
      }
    },
    {
      path: '/purchaseRedeemIndex',
      name: 'purchaseRedeemIndex',
      component: () => import('@/view/groupPurchaseRedeem/purchaseRedeemIndex'),
      meta:{
        title:"花点时间企业服务",
      }
    },
    {
      path: '/purchaseRedeemCoupon',
      name: 'purchaseRedeemCoupon',
      component: () => import('@/view/groupPurchaseRedeem/purchaseRedeemCoupon'),
      meta:{
        title:"花点时间企业服务",
      }
    },
    {
      path: '/elizabeth',
      name: 'elizabeth',
      component: Elizabeth,
      meta:{
        title:"Elizabeth",
      }
    }

    
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js